export default {
  '/applicationBuilder': {
    id: 'dashboard',
    steps: [
      {
        title: 'Bienvenue dans le studio SWIZI !',
        content: 'Voici les quelques étapes nécessaires pour créer votre première App Mobile SWIZI',
        target: '',
      },
      {
        title: 'Initialisez votre App !',
        content: 'Rendez vous dans le  menu design pour initialiser votre App',
        target: '[id=design]>span',
        placement: 'right',

      },
      {
        title: 'Choisissez un style',
        content: 'Dans le menu navigation, vous pouvez choisir un style d\'application',
        target: '[id=navigation]>span',
        placement: 'right',
      },
      {
        title: 'Ajoutez du contenu',
        content: 'Enrichissez votre application en créant des sections',
        target: '[id=content]>span',
        placement: 'right',
      },
      {
        title: 'Gérez vos images et vidéos',
        content: 'La bibliothèque contient les images et les vidéos publiées dans les sections de l\'application',
        target: '[id=library]>span',
        placement: 'right',
      },
      {
        title: 'Téléchargez l\'application SWIZI Player',
        content: 'L\'application SWIZI Player, disponible sur iOS et Android, vous permet de simuler l\'application ' +
        '<br/>mobile avant son déploiement sur les stores',
        target: '[id=viewer]',
        placement: 'bottom',
      },
      {
        title: 'Utilisez l\'aide en ligne',
        content: 'A tout moment, cliquez sur le point d\'interrogation pour obtenir de l\'aide',
        target: '[id=help]',
        placement: 'bottom',
      }, /*
      {
        title: 'Utilisez l\'aide en ligne',
        content: 'blavla',
        target: '[id=uploader]',
        placement: 'bottom',
      },*/
    ],
  },
  '/applicationBuilder/design': {
    id: 'design',
    steps: [
      {
        title: 'Cet écran vous permet de définir les éléments de base de votre application',
        content: 'C\'est ici que vous définissez l\'identité de votre App Mobile. <br/>' +
        'Quel est son nom ? Quelle est son ' +
        'apparence ? <br/>' +
        'Comment est elle visible sur le smartphone et les stores ?',
        target: '',
        placement: 'bottom',
      },
      {
        title: 'Choisissez un nom d\'application',
        content: 'Pensez à utiliser un nom qui ne soit pas trop commun pour que<br/>' +
        'les moteurs de recherche le référence plus facilement',
        target: '[for=name]',
        placement: 'right',
      },
      {
        title: 'Choisissez votre icône d\'application',
        content: 'Cette icone représente votre application sur l\'écran du smartphone, <br/>dans la barre de ' +
        'notification et sur les stores.',
        target: '[for=icon]',
        placement: 'left',
      },
      {
        title: 'Choisissez votre splashscreen',
        content: 'Le splashscreen est une image plein écran qui s\'affiche au démarrage de l\'application <br/>' +
        'pendant quelques secondes. C\'est le message de bienvenue.',
        target: '[name=splash]',
        placement: 'left',
      },
      {
        title: 'Choisissez les couleurs dominantes de l\'application',
        content: 'Choisissez les couleurs de votre application parmi les thèmes proposés<br/>' +
        'ou créez votre thème avec des couleurs personnalisées. ',
        target: '[id=palettes]',
        placement: 'left',
      },
    ],
  },
  '/applicationBuilder/users': {
    id: 'design',
    steps: [
      {
        title: 'Gérez les utilisateurs de l\'App',
        content: 'Cette zone vous permet de gérer qui a accès à votre application.',
        target: '',
      },
      {
        title: 'Définir le type de public adressé',
        content: 'Dans les paramètres vous pouvez décider si le contenu de votre <br/>application est accessible ' +
        'à tout le monde ou uniquement à des utilisateurs identifiés.',
        target: '[id=edit]',
        placement: 'left',
      },
      {
        title: 'Ajouter un utilisateur',
        content: 'Les utilisateurs sont des mobinautes qui peuvent s\'identifier dans votre '+
        'application avec un mot de passe.<br/>Vous pouvez classer les utilisateurs '+
        'dans des groupes pour afficher des contenus différents selon' +
        ' les groupes.',
        target: '[id=addUser]', // #ID Ajouter utilisateur
        placement: 'right',
      },
      {
        title: 'Créer des groupes',
        content: 'Vous pouvez définir des groupes et affecter les utilisateurs à un ou plusieurs groupes.<br/>' +
        'Cette gestion vous permet de personnaliser les contenus et les notifications.',
        target: '[id=addGroup]',
        placement: 'left', // #ID Ajouter groupe
      },
    ],
  },
  '/applicationBuilder/iot': {
    id: 'poi',
    steps: [
      {
        title: 'Gérez des points d\'intérêt indoor ou outdoor',
        content: 'Cette zone vous permet de définir des points d\'intérêt intérieurs en les associants<br/>' +
        'à des beacons ou extérieurs en les positionnant sur une carte.',
        target: '',
      },
      {
        title: 'Ajouter un POI intérieur',
        content: 'Un beacon est un petit équipement qui fonctionne avec une pile et qui émet un signal <br/>' +
        'en permance. Ce signal contient contient un identifiant unique. Il est possible de demander à <br/>' +
        'l\'application d\'adopter un comportenant donné lorsqu\'elle capte le signal d\'un Beacon,',
        target: '',
        placement: '',
      },
      {
        title: 'Ajouter un POI extérieur',
        content: 'Les POI extérieur sont des points positionnés à une adresse donnée. Ces points sont affichés<br/>' +
        'sur une carte. L\'utilisateur peur consulter le contenu associé à chaque point ou demander un guidage<br/>' +
        'avec son application GPS préférée.',
        target: '[id=menuAddType]', // #ID Ajouter utilisateur
        placement: 'right',
      },
      {
        title: 'Créer des groupes',
        content: 'Vous pouvez définir des groupes et affecter les utilisateurs à un ou plusieurs groupes.<br/>' +
        'Cette gestion vous permet de personnaliser les contenus et les notifications.',
        target: '[id=addGroup]',
        placement: 'left', // #ID Ajouter groupe
      },
    ],
  },
  '/applicationBuilder/iot/beacon': {
    id: 'beacons',
    steps: [
      {
        title: 'Choisissez le type de beacon',
        content: 'Choisissez le nom du fabricant du beacon que vous voulez configurer.<br/>',
        target: '[id=menuAddType]',
      },
      {
        title: 'Choisir un nom',
        content: 'Choisissez un nom pour le beacon. Par exemple "Cuisine" ',
        target: '',
        placement: '',
      },
      /*
      {
        title: 'Ajouter un POI extérieur',
        content: 'Les POI extérieur sont des points positionnés à une adresse donnée. Ces points sont affichés<br/>' +
        'sur une carte. L\'utilisateur peur consulter le contenu associé à chaque point ou demander un guidage<br/>' +
        'avec son application GPS préférée.',
        target: '[id=menuAddType]', // #ID Ajouter utilisateur
        placement: 'right',
      },
      {
        title: 'Créer des groupes',
        content: 'Vous pouvez définir des groupes et affecter les utilisateurs à un ou plusieurs groupes.<br/>' +
        'Cette gestion vous permet de personnaliser les contenus et les notifications.',
        target: '[id=addGroup]',
        placement: 'left', // #ID Ajouter groupe
      },
      */
    ],
  },
  /* '/account/myteam': {
    id: 'helpTeam',
    steps: [
      {
        title: 'Titre à compléter',
        content: 'Contenu à compléter',
        target: '[id=helpTeam]',
      },
    ],
  },*/
}
